
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import tabla from './tabla/tabla.vue';
    import barrainferior from './barrainferior/barrainferior.vue';
    import barraderecha from './barraderecha/barraderecha.vue';
    import barraizquierda from './barraizquierda/barraizquierda.vue';
    import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            tabla,
            barrainferior,
            barraderecha,
            barraizquierda,
        }

    } )
    export default class Componente extends Vue
    {
        public Controlador: ControladorInterfaz = null;
        public get Estado() { return this.Controlador.Vista.Estado; }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        created()
        {
            this.Controlador = new ControladorInterfaz();

            this.Controlador.Vista.BarraDebajo.Altura.Espacio = 70;
            this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 400;
            this.Controlador.Vista.BarraIzquierda.Anchura.Espacio = 400;

            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            this.Eventos.push( this.Controlador.EdicionPedido.onVendedor.subscribe( () => this.onCambios() ) );
            this.Eventos.push( this.Controlador.EdicionPedido.onCliente.subscribe( () => this.onCambios() ) );
            this.Eventos.push( this.Controlador.EdicionPedido.onTipo.subscribe( () => this.onCambios() ) );

            if ( this.$route.params.tipo )
            {
                if ( this.$route.params.tipo == 'normales' )
                    this.Controlador.EdicionPedido.Modo = 'normal';
                else
                    this.Controlador.EdicionPedido.Modo = 'mostrador';
                this.Controlador.Iniciar();
            }
            else if ( this.$route.params.id )
            {
                this.Controlador.Iniciar( parseInt( this.$route.params.id ) );
            } else
            {
                this.Controlador.Iniciar();
            }


        }


        onCambios()
        {

            if ( !this.Controlador.EdicionPedido.Tipo || this.Controlador.EdicionPedido.Tipo.esNoEspecificado )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'nuevo';
            }
            else if ( !this.Controlador.EdicionPedido.Vendedor || !this.Controlador.EdicionPedido.Vendedor.Existe )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'vendedores';
            }
            else if ( !this.Controlador.EdicionPedido.Cliente || !this.Controlador.EdicionPedido.Cliente.Existe )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'clientes';
            } else
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
            }

        }


        onKeyUp( e: KeyboardEvent )
        {
            if ( e.key == 'F1' )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'menu';
            }
            else if ( e.key == 'F10' )
            {
                if ( this.Controlador.EdicionPedido.Iniciado )
                    this.Controlador.Vista.BarraIzquierda.Modo = 'finalizar';
            }
            else if ( e.key == 'g' && e.ctrlKey )
            {
                if ( this.Controlador.EdicionPedido.Iniciado )
                    this.Controlador.Vista.BarraIzquierda.Modo = 'guardar';
            }
            else if ( e.key == 'e' && e.ctrlKey )
            {
                if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
                {
                    this.Controlador.Vista.BarraIzquierda.SubModo = 'nuevo';
                    this.Controlador.Vista.BarraIzquierda.Modo = 'guardar';

                } else
                {
                    this.Controlador.Vista.BarraIzquierda.Modo = 'nuevo';
                }
            }
            else if ( e.key == 'a' && e.ctrlKey )
            {

                if ( this.Controlador.EdicionPedido.Iniciado && this.Controlador.ComprobarGuardadoAutomatico() )
                {
                    this.Controlador.Vista.BarraIzquierda.SubModo = 'pedidos';
                    this.Controlador.Vista.BarraIzquierda.Modo = 'guardar';

                } else
                {
                    this.Controlador.Vista.BarraIzquierda.Modo = 'pedidos';
                }
            }
            else if ( e.key == 'q' && e.ctrlKey )
            {
                if ( this.Controlador.EdicionPedido.Modo == 'mostrador' )
                    this.Turnero();
            }
        }


        Turnero()
        {
            if ( this.Controlador.Vista.BarraDerecha.Modo == 'turnero' )
                this.Controlador.Vista.BarraDerecha.Modo = '';
            else
            {
                this.Controlador.Vista.BarraDerecha.Modo = 'turnero';
            }
        }

    }
